import type {
  Control,
  UseFormGetValues,
  UseFormSetValue,
} from "react-hook-form";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import APIS from "../../constant/EndPoint";
import type { IFilterRunsheet } from "../../types/interface";
import { classNames } from "../../utils/classNames";
import ComboboxFilter from "../Reusable/ComboboxFilter";
import DateRangePicker from "../Reusable/DateRangePicker";

interface Props {
  setValue: UseFormSetValue<IFilterRunsheet>;
  getValues: UseFormGetValues<IFilterRunsheet>;
  isFilterVisible: boolean;
  control: Control<IFilterRunsheet, any>;
  handleFilterReset: () => void;
}

const RunsheetFilter = ({
  setValue,
  getValues,
  handleFilterReset,
  isFilterVisible,
  control,
}: Props) => {
  return (
    <div
      className={classNames(
        isFilterVisible ? tw`block` : tw`hidden`,
        tw`relative`
      )}
    >
      {isFilterVisible ? (
        <div className={tw`grid grid-cols-3 md:grid-cols-3 gap-x-4 mx-4`}>
          <DateRangePicker
            label={"Select Date Range"}
            setValue={setValue}
            name={"created__range"}
            getValues={getValues}
          />
          <ComboboxFilter<IFilterRunsheet>
            url={APIS.VEHICLE}
            queryKey={"vehicle"}
            name={"vehicle"}
            params={{ is_active: true }}
            label={"Vehicle Number"}
            placeholder={"Search vehicle"}
            control={control}
          />
          <ComboboxFilter<IFilterRunsheet>
            url={APIS.DRIVER}
            queryKey={"driver"}
            name={"driver"}
            label={"Driver"}
            params={{ is_active: true }}
            placeholder={"Search driver"}
            control={control}
          />
        </div>
      ) : (
        ""
      )}
      <button
        className={tw`absolute -top-5 right-5`}
        onClick={handleFilterReset}
      >
        Reset
      </button>
    </div>
  );
};

export default RunsheetFilter;
